interface PersistDocumentBeforeReadInput<ContentSnapshot, SaveResult> {
  documentId: string
  snapshot: ContentSnapshot
  title?: string
  persistedTitle?: string
  toMarkdown: (snapshot: ContentSnapshot) => Promise<string>
  save: (document: {
    id: string
    contentJson: ContentSnapshot
    content: string
    title?: string
  }) => Promise<SaveResult>
}

export type SerialTaskQueue = <Result>(task: () => Promise<Result>) => Promise<Result>

export function createSerialTaskQueue(): SerialTaskQueue {
  let tail: Promise<unknown> = Promise.resolve()

  return <Result>(task: () => Promise<Result>) => {
    const result = tail.catch(() => undefined).then(task)
    tail = result.catch(() => undefined)
    return result
  }
}

export async function persistDocumentBeforeRead<ContentSnapshot, SaveResult>({
  documentId,
  snapshot,
  title,
  persistedTitle,
  toMarkdown,
  save,
}: PersistDocumentBeforeReadInput<ContentSnapshot, SaveResult>): Promise<SaveResult> {
  const content = await toMarkdown(snapshot)
  const normalizedTitle = title?.trim() || (title === undefined ? undefined : 'Untitled')
  return save({
    id: documentId,
    contentJson: snapshot,
    content,
    ...(normalizedTitle === undefined || normalizedTitle === persistedTitle
      ? {}
      : { title: normalizedTitle }),
  })
}
